import { store } from "@betacrew/jars-flux";
import { all, call, put, select, takeLatest } from "redux-saga/effects";
import { FORM_LISTING_LOADING_STATES } from "../constants";
import FormsDataService from "../../../../../services/FormsDataService";
import Forms from "../../../../../libs/utility/formsutility/Forms";
import { componentKey, setCategorisedFormFields, setFormDetails, setLoadingState, setTinVerificationAmount } from "./FormDetailsDrawerSlice";
import { addNotifications } from "../../../toaster/ToasterPortalSlice";
import { TOASTER_VARIANT } from "../../../../components/toast/constants";
import RecipientDataService from "../../../../../services/RecipientDataService";
import General from "../../../../../libs/utility/General";

export const { getFormDetails } = {

    getFormDetails: (payload) => {
        return {
            type: "FORM_DETAILS_DRAWER/GET_FORM_DETAILS",
            payload
        }
    },
}

function* getFormDetailsAsync(action) {

    try {
        yield put(setLoadingState({ state: FORM_LISTING_LOADING_STATES.GET_FORM_DETAILS_LOADING }))

        const { formRecordId, formName, year } = action.payload;

        const [formDetailsResponse, formFieldsResponse] = yield all([
            call(FormsDataService.getFormDetails, formName, formRecordId),
            call(FormsDataService.getFormFields, formName, year),
        ]);
        const tinVerificationCostResponse = yield RecipientDataService.getTinMatchFee(1);
        
        const { Message, Status, Data } = formDetailsResponse?.data;

        if (Status && formFieldsResponse?.data?.Status) {
            const processedFields = Forms.getCategorisedFormFields(formFieldsResponse?.data?.Data, Data);
            yield put(setCategorisedFormFields(processedFields))
            yield put(setFormDetails(Data))
        } else {
            yield put(addNotifications({ heading: "Failed to fetch selected form details", message: Message, variant: TOASTER_VARIANT.DANGER }));
        }

        if(tinVerificationCostResponse?.data?.Status) {
            yield put(setTinVerificationAmount( General.getDecimalAmount(tinVerificationCostResponse?.data?.Data)) )
        }
    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Failed to fetch selected forms", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: FORM_LISTING_LOADING_STATES.GET_FORM_DETAILS_READY }))
    }

}

function* rootSaga() {
    yield all([
        takeLatest(getFormDetails().type, getFormDetailsAsync),
    ]);
}

store.sagaManager.addSaga(componentKey, rootSaga);